var image_upload_default = {
  "container": "pHP-M",
  "disabled": "S8T45",
  "imageInput": "pd2Ho",
  "overlay": "_45daJ",
  "text": "_6HfMp",
  "shown": "g-M6L",
  "hide": "fjWUv",
  "spinner": "Q747o",
  "spin": "wT2v1"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
